import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import type GetCategoriesSortOrderDto from "./dto/get-categories-sort-order.dto";
import type UpdateCategoriesSortOrderDto from "./dto/update-categories-sort-order.dto";

export const CategorySortOrderEffectActions = {
  getCategoriesSortOrder: `${Entities.CategorySortOrder}_getCategoriesSortOrder`,
  updateCategoriesSortOrder: `${Entities.CategorySortOrder}_updateCategoriesSortOrder`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.CategorySortOrder,
  initSchema,
  aliasName: DIContainerKeys.CategorySortOrderService,
})
export class CategorySortOrderService extends HttpService {
  @loader(Loaders.GetCategoriesSortOrderLoader)
  @action(DIContainerKeys.CategorySortOrderService)
  public *getCategoriesSortOrder(dto: GetCategoriesSortOrderDto): any {
    yield this.setLoaderState(Loaders.GetCategoriesSortOrderLoader, true);
    const response = yield call(
      this.get,
      {
        url: BASE_API_PATHS.getCategoriesSortOrder,
        domain: API_DOMENS.PSA_API,
        params: {
          SortOrderFor: dto.type,
        }
      },
      ReducerMethods.UPDATE
    );
    if (!response?.Success) {
      yield this.setLoaderState(Loaders.GetCategoriesSortOrderLoader, false);
      return;
    }
    const state = yield this.di.reduxStore.state()?.[Entities.CategorySortOrder]?.[dto.clientId] ?? {};
    const payload = {
      ...state,
      [dto.type]: response?.Data,
    }
    yield this.setEntityStateById(Entities.CategorySortOrder, dto.clientId, payload);
    yield this.setLoaderState(Loaders.GetCategoriesSortOrderLoader, false);
  }

  @action(DIContainerKeys.CategorySortOrderService)
  public *updateCategoriesSortOrder(dto: UpdateCategoriesSortOrderDto): any {
    yield call(
      this.post,
      {
        url: BASE_API_PATHS.updateCategorySortOrder,
        domain: API_DOMENS.PSA_API,
        body: this.toFormData({
          SortOrderFor: dto.type,
          SortingList: dto.list,
        }),
      },
      ReducerMethods.UPDATE
    );
    yield this.getCategoriesSortOrder({
      clientId: dto.clientId,
      type: dto.type,
    });
  }
}
